function t(t,e){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=e.templates;return"ButtonTemplates"===t?n[t]:a[t]||n[t]}export{t as default};
